import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Header from "../../components/Header";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config";

const ManageDiscipline = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const discipline = location.state?.discipline || {};
  const navigate = useNavigate();

  const handleFormSubmit = async (values, {resetForm}) => {
    console.log(values);
    try {
      let response;
      if (values.disciplineId) {
        // Update existing subscription
        response = await axios.put(
          `${config.apiBaseUrl}/update_discipline/${values.disciplineId}`,
          values,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${document.cookie
                .split("; ")
                .find((row) => row.startsWith("teba_auth_token="))
                ?.split("=")[1]}`,
            },
          }
        );
        toast.success("Discipline updated successfully", {
          onClose: () => {
            navigate("/discipline_list");
          }
        });
      } else {
        // Add new subscription
        response = await axios.post(
          `${config.apiBaseUrl}/add_discipline`,
          values,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${document.cookie
                .split("; ")
                .find((row) => row.startsWith("teba_auth_token="))
                ?.split("=")[1]}`,
            },
          }
        );
        toast.success("Discipline added successfully");
        resetForm();
      }
      console.log(response.data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to save discipline");
    }
  };

  const initialValues = {
    disciplineId : discipline.discipline_id || "",
    disciplineName: discipline.discipline_name || "",
  };

  return (
    <Box m={{ xs: "12px", sm: "16px", md: "20px" }}>
      <Header title="ADD | MODIFY Discipline" subtitle="Create or Modify a Discipline" />
      <ToastContainer />
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          setFieldValue,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap={{ xs: "14px", sm: "18px", md: "24px" }}
              gridTemplateColumns={{ xs: "repeat(1, minmax(0, 1fr))", sm: "repeat(2, minmax(0, 1fr))", lg: "repeat(4, minmax(0, 1fr))" }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Discipline Name"
                onBlur={handleBlur}
                onChange={(e) => setFieldValue("disciplineName", e.target.value)}
                value={values.disciplineName}
                name="disciplineName"
                error={!!touched.disciplineName && !!errors.disciplineName}
                helperText={touched.disciplineName && errors.disciplineName}
                sx={{ gridColumn: { xs: "span 1", sm: "span 2", lg: "span 2" } }}
              />
            </Box>
            <Box display="flex" justifyContent="flex-start" flexWrap="wrap" gap={1} mt={{ xs: 3, sm: 4, md: 5 }}>
              <Button type="submit" color="secondary" variant="contained" size={isMobile ? "small" : "medium"}>
                Save
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  disciplineName: yup.string().required("required")
});



export default ManageDiscipline;